import { target } from "@github/catalyst";
import { controller } from "./controller";

@controller
export default class XaPasswordElement extends HTMLElement {
  @target input: HTMLInputElement | undefined;
  @target toggelPassword: HTMLElement | undefined;
  oldPassword: string | undefined = "";
  newPassword: string | undefined = "";
  timer: number | null = null;
  @target passCopy: HTMLFormElement | undefined;
  connectedCallback(): void {
    if (this.input && this.passCopy) {
      this.input.style.display = "none";
      this.newPassword = this.input.value;
      this.passCopy?.addEventListener("focus", () => {
        this.start();
      });
      this.passCopy?.addEventListener("blur", () => {
        this.stop();
      });
      this.passCopy.value = this.createBullets(this.input.value.length);
      this._inputOnInputHandler();

      this.passCopy?.addEventListener("input", () => {
        this._inputOnInputHandler();
      });
    } else if (this.input && this.toggelPassword) {
      this.toggelPassword?.addEventListener("click", () => {
        this._toggelPassword();
      });
    }
  }
  _toggelPassword(): void {
    if (this.input && this.toggelPassword) {
      if (this.input.type === "password") {
        this.input.type = "text";
        this.toggelPassword.textContent = "Hide";
      } else {
        this.input.type = "password";
        this.toggelPassword.textContent = "Show";
      }
    }
  }
  start(): void {
    this.timer = window.setInterval(() => {
      const valuelength = this.passCopy?.value.length;
      if (
        this.passCopy &&
        !(this.passCopy?.selectionEnd === valuelength && this.passCopy?.selectionStart <= valuelength)
      ) {
        this.passCopy.selectionStart = valuelength;
        this.passCopy.selectionEnd = valuelength;
      }
    }, 100);
  }
  stop(): void {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
  _inputOnInputHandler(): void {
    if (this.input && this.passCopy) {
      this.copyPass();
      const textbox = this.passCopy;
      if (this.rsInputFilterHandling(this.newPassword)) {
        textbox.oldValue = this.createBullets(textbox.value.length);
        this.oldPassword = this.newPassword;
        textbox.oldSelectionStart = textbox.selectionStart;
        textbox.oldSelectionEnd = textbox.selectionEnd;
      } else if (textbox.oldValue) {
        if (textbox.value.length !== textbox.oldValue.length) {
          textbox.value = textbox.oldValue;
        }
        this.newPassword = this.oldPassword;
        textbox.setSelectionRange(textbox.oldSelectionStart, textbox.oldSelectionEnd);
      } else {
        textbox.value = "";
        this.newPassword = "";
      }
      this.input.value = this.newPassword || "";
      const eventType = this.input.getAttribute("rsvalidatoreventtype");
      if (eventType) {
        this.input.dispatchEvent(new Event(eventType, { bubbles: true }));
      }
    }
    setTimeout(() => {
      if (this.input && this.passCopy) {
        this.passCopy.value = this.createBullets(this.input.value.length);
      }
    }, 200);
  }
  rsInputFilterHandling(value: string | undefined): boolean {
    const filterRegexStr = this.input?.getAttribute("rsinputfilter");

    if (filterRegexStr && filterRegexStr !== "undefined" && filterRegexStr !== "null" && value !== undefined) {
      const filterRegex = new RegExp(filterRegexStr);
      return filterRegex.test(value.toString());
    }

    return false;
  }
  copyPass(): void {
    if (this.passCopy && this.newPassword !== undefined) {
      const oPass = this.newPassword;
      const nPass = this.passCopy.value;
      if (nPass.length < oPass.length) {
        this.newPassword = oPass.substr(0, nPass.length);
      } else if (nPass.length > oPass.length) {
        this.newPassword = oPass + nPass.substr(oPass.length);
      }
    }
  }
  createBullets(n: number): string {
    let bullets = "";
    for (let i = 0; i < n; i++) {
      bullets += "•";
    }
    return bullets;
  }
}

declare global {
  interface Window {
    XaPasswordElement: typeof XaPasswordElement;
  }
  interface HTMLElementTagNameMap {
    "xa-Password": XaPasswordElement;
  }
}

if (!window.customElements.get("xa-password")) {
  window.XaPasswordElement = XaPasswordElement;
  window.customElements.define("xa-password", XaPasswordElement);
}
